var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.step')}},[_c('el-input-number',{staticClass:"hide-spin-button",staticStyle:{"width":"100%"},model:{value:(_vm.optionModel.step),callback:function ($$v) {_vm.$set(_vm.optionModel, "step", $$v)},expression:"optionModel.step"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }